import Deposits from './views/deposits.c';
export default Deposits;
